import {
  ESyncfusionFieldType,
  ETestruleCategory,
  ETestruleFieldType,
  IOperator,
} from "../../testrules-query-builder/testrules-query-builder-enums-and-interfaces";


export const testruleCategoryLabels: Record<ETestruleCategory, string> = {
  [ETestruleCategory.trapoError]: 'Trapo zuordnen rot',
  [ETestruleCategory.trapoWarning]: 'Trapo zuordnen orange',
  [ETestruleCategory.checkError]: 'Prüfung rot',
  [ETestruleCategory.checkWarning]: 'Prüfung orange',
}

export const apiTypeSyncFusionTypeMap: Record<ETestruleFieldType, ESyncfusionFieldType> = {
  [ETestruleFieldType.string]: ESyncfusionFieldType.string,
  [ETestruleFieldType.function]: ESyncfusionFieldType.string,
  [ETestruleFieldType.object]: ESyncfusionFieldType.string,
  [ETestruleFieldType.property]: ESyncfusionFieldType.string,
  [ETestruleFieldType.decimal]: ESyncfusionFieldType.number,
  [ETestruleFieldType.integer]: ESyncfusionFieldType.number,
  [ETestruleFieldType.boolean]: ESyncfusionFieldType.boolean,
  [ETestruleFieldType.date]: ESyncfusionFieldType.date,
};

export const operatorMapModelToApi: Record<string, string> = {
  'startswith': 'starts_with',
  'notstartswith': 'not_starts_with',
  'endswith': 'ends_with',
  'notendswith': 'not_ends_with',
  'contains': 'contains',
  'notcontains': 'not_contains',
  'equal': 'equal',
  'notequal': 'not_equal',
  'greaterthan': 'greater_than',
  'greaterthanorequal': 'greater_than_or_equal',
  'lessthan': 'less_than',
  'lessthanorequal': 'less_than_or_equal',
  'between': 'between',
  'notbetween': 'not_between',
  'in': 'in',
  'notin': 'not_in',
  'isempty': 'is_empty',
  'isnotempty': 'is_not_empty',
  'isnull': 'is_null',
  'isnotnull': 'is_not_null',
  'matches': 'matches',
};

export const typeOperatorsMap: Record<ETestruleFieldType, IOperator[]> = {
  [ETestruleFieldType.string]: [
    {key: 'Gleich', value: 'equal'},
    {key: 'Ungleich', value: 'not_equal'},
    {key: 'Entspricht', value: 'matches'},
    // {key: 'Beginnt mit', value: 'starts_with'},
    // {key: 'Nicht zwischen', value: 'ends_with'},
  ],
  [ETestruleFieldType.object]: [
    {key: 'Gleich', value: 'equal'},
    {key: 'Ungleich', value: 'not_equal'},
    {key: 'Entspricht', value: 'matches'},
    // {key: 'Beginnt mit', value: 'starts_with'},
    // {key: 'Nicht zwischen', value: 'ends_with'},
  ],
  [ETestruleFieldType.date]: [
    {key: 'Gleich', value: 'equal'},
    {key: 'Ungleich', value: 'not_equal'},
    {key: 'Größer als', value: 'greater_than'},
    {key: 'Kleiner als', value: 'less_than'},
    {key: 'Größer oder gleich', value: 'greater_than_or_equal'},
    {key: 'Kleiner oder gleich', value: 'less_than_or_equal'},
    // {key: 'Endet mit', value: 'between'},
    // {key: 'Zwischen', value: 'not_between'},
  ],
  [ETestruleFieldType.boolean]: [
    {key: 'Gleich', value: 'equal'},
    {key: 'Ungleich', value: 'not_equal'},
  ],
  [ETestruleFieldType.decimal]: [
    {key: 'Gleich', value: 'equal'},
    {key: 'Ungleich', value: 'not_equal'},
    {key: 'Größer als', value: 'greater_than'},
    {key: 'Kleiner als', value: 'less_than'},
    {key: 'Größer oder gleich', value: 'greater_than_or_equal'},
    {key: 'Kleiner oder gleich', value: 'less_than_or_equal'},
    // {key: 'Endet mit', value: 'between'},
    // {key: 'Zwischen', value: 'not_between'},
  ],
  [ETestruleFieldType.integer]: [
    {key: 'Gleich', value: 'equal'},
    {key: 'Ungleich', value: 'not_equal'},
    {key: 'Größer als', value: 'greater_than'},
    {key: 'Kleiner als', value: 'less_than'},
    {key: 'Größer oder gleich', value: 'greater_than_or_equal'},
    {key: 'Kleiner oder gleich', value: 'less_than_or_equal'},
    // {key: 'Endet mit', value: 'between'},
    // {key: 'Zwischen', value: 'not_between'},
  ],
  [ETestruleFieldType.property]: [
    {key: 'Gleich', value: 'equal'},
    {key: 'Ungleich', value: 'not_equal'},
    {key: 'Entspricht', value: 'matches'},
    // {key: 'Beginnt mit', value: 'starts_with'},
    // {key: 'Nicht zwischen', value: 'ends_with'},
    {key: 'Größer als', value: 'greater_than'},
    {key: 'Kleiner als', value: 'less_than'},
    {key: 'Größer oder gleich', value: 'greater_than_or_equal'},
    {key: 'Kleiner oder gleich', value: 'less_than_or_equal'},
    // {key: 'Endet mit', value: 'between'},
    // {key: 'Zwischen', value: 'not_between'},
  ],
  [ETestruleFieldType.function]: [
    {key: 'Gleich', value: 'equal'},
    {key: 'Ungleich', value: 'not_equal'},
    {key: 'Entspricht', value: 'matches'},
    // {key: 'Beginnt mit', value: 'starts_with'},
    // {key: 'Nicht zwischen', value: 'ends_with'},
    {key: 'Größer als', value: 'greater_than'},
    {key: 'Kleiner als', value: 'less_than'},
    {key: 'Größer oder gleich', value: 'greater_than_or_equal'},
    {key: 'Kleiner oder gleich', value: 'less_than_or_equal'},
    // {key: 'Endet mit', value: 'between'},
    // {key: 'Zwischen', value: 'not_between'},
  ],
}
